App.namespace.wrap('components.selection_tracking', (targetTextNode, callback, debounceTime = 1000) => {
  const listener = (event) => {
    // not supported
    if (!document.getSelection) {
      return;
    }

    const selection = document.getSelection().toString().trim();

    // selection is empty - ignore
    if (!selection) {
      return;
    }

    // ignore selection to text that we don't track
    if (window.getSelection().anchorNode !== targetTextNode) {
      return;
    }

    callback(event, selection);
  };

  const listenerDebounced = App.es6.shared.debounce(
    listener,
    debounceTime,
    false,
  );

  document.addEventListener('selectionchange', listenerDebounced);
  document.addEventListener('copy', listener);
});
